/* eslint-disable react/display-name */
// noinspection XmlDeprecatedElement

import React, { useState } from "react";

type inputTypes = {
  [key: string]: boolean;
};
const inputTypesEnum: inputTypes = {
  input: true,
};

type Props = {
  inputType?: string;
  onSubmit: (data: any) => void;
  onClose: () => void;
  isStateless?: boolean;
  placeholder?: string;
  StandardInput?: any;
  value: any;
};

export default (props: Props) => {
  const [inputValue, setInputValue] = useState(props.value);

  // @todo
  /*if (inputValue === '' && props.value !== '') {
        setInputValue(props.value);
    }*/

  const onInputValueChange: (ev: any) => void = (ev: any): void => {
    setInputValue(ev.currentTarget.value);
  };

  const onSubmit: () => void = (): void => {
    if (inputValue !== "") {
      // @todo inputValue.trim
      props.onSubmit(inputValue);
    } else {
      props.onClose();
    }
  };

  if (
    typeof props.inputType === "undefined" ||
    typeof inputTypesEnum[props.inputType] === "undefined"
  ) {
    // Tiny validation
    console.log(
      "EditableInput.js - no props.inputType given or invalid value. Aborting.",
      props.inputType,
    );
    return null;
  }

  return (
    <div className="editable-input">
      {props.inputType === "input" && (
        <input
          autoFocus
          type="text"
          className={
            typeof props.isStateless !== "undefined" && props.isStateless ? "stateless" : ""
          }
          placeholder={typeof props.placeholder !== "undefined" ? props.placeholder : ""}
          // maxlength = 255
          value={inputValue}
          onChange={onInputValueChange}
          onKeyPress={(ev) => {
            if (ev.key === "Enter") {
              onSubmit();
            }
          }}
          //onBlur={props.onClose}
        />
      )}
      {props.StandardInput === "undefined" && (
        <div className="editable-input__buttons">
          <button onClick={onSubmit}>
            <i className="fi fi-check"></i>
          </button>
          <button onClick={props.onClose}>
            <i className="fi fi-x"></i>
          </button>
        </div>
      )}
    </div>
  );
};
